var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyXlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9214 9.00154L17.9949 9.98309L8.69179 14.7216C8.66033 14.4817 8.6445 14.24 8.6444 13.998C8.64567 13.0325 8.89917 12.084 9.37977 11.2466C9.86037 10.4092 10.5514 9.71191 11.3844 9.22376C12.2175 8.7356 13.1636 8.47354 14.129 8.46353C15.0945 8.45353 16.0458 8.69592 16.8888 9.16671L17.9915 8.60486L18.156 8.52092C17.1458 7.78772 15.9526 7.3481 14.7082 7.25065C13.4638 7.15319 12.2167 7.40169 11.1047 7.96869C9.99273 8.53568 9.05916 9.39909 8.40719 10.4635C7.75521 11.5279 7.41022 12.7518 7.41035 14C7.41035 14.1724 7.4169 14.3441 7.42998 14.5152C7.44831 14.7574 7.39459 14.9996 7.27559 15.2114C7.15658 15.4231 6.9776 15.5949 6.76117 15.7052L6.17969 16.0017V17.3847L7.89165 16.5121L8.44606 16.2292L8.99235 15.9509L18.7998 10.9538L19.9018 10.3926L22.1797 9.2317V7.8494L19.9214 9.00154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1797 10.6152L9.54946 17.0461L8.44741 17.6086L6.17969 18.7642V20.1458L8.43185 18.9984L10.3584 18.0168L19.671 13.2715C19.7025 13.513 19.7183 13.7563 19.7184 13.9999C19.7178 14.9665 19.4643 15.9162 18.9833 16.7546C18.5022 17.593 17.8102 18.2911 16.976 18.7794C16.1418 19.2677 15.1943 19.5293 14.2277 19.5383C13.2611 19.5473 12.309 19.3032 11.4659 18.8305L11.3982 18.8664L10.2027 19.4756C11.2126 20.2088 12.4056 20.6486 13.6498 20.7463C14.894 20.844 16.141 20.5958 17.253 20.0292C18.365 19.4626 19.2987 18.5996 19.9509 17.5356C20.6032 16.4716 20.9486 15.2479 20.949 13.9999C20.949 13.8259 20.9423 13.652 20.9294 13.48C20.9111 13.2379 20.9647 12.9958 21.0836 12.784C21.2025 12.5723 21.3813 12.4004 21.5975 12.29L22.1797 11.9935V10.6152Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13.5387,
    fill: "white",
    transform: "translate(6.17969 7.23047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyXlm);
export default __webpack_public_path__ + "static/media/Currency=XLM.d4f24d5a6ca892fe26c4897886a73fbd.svg";
export { ForwardRef as ReactComponent };